// Libs
import React, { useState, useEffect } from 'react';
import { Collapse, Icon } from 'antd';

// Own Libs
import * as ui from '@digital/ui';

//Api
import {
    getCrfFechamentoModuloExecutadoByFechamentoId,
    ICrfFechamentoRegistroEsin204,
} from '@app/api/crf/crffechamento';

//Files
import FechamentoModuloExecutadoTabela from './fechamentoModuloExecutadoTabela';

//Utils
const { Panel } = Collapse;

interface IFechamentoModuloExecutadoProps {
    fechamentoId: string;
}

const FechamentoModuloExecutado = (props: IFechamentoModuloExecutadoProps) => {

    const { fechamentoId } = props;

    const [cicloOrcamentarioRelatorioTotal, setCicloOrcamentarioRelatorioTotal] = useState<ICrfFechamentoRegistroEsin204[]>();

    useEffect(() => {
        if (fechamentoId) {
            getCrfFechamentoModuloExecutadoByFechamentoId(fechamentoId).then((data) => {
                if (data && data.length > 0) {
                    setCicloOrcamentarioRelatorioTotal(data);
                }
            });
        }

    }, [fechamentoId]);

    const carregarTadadosDaTabela = (ano: number) => {
        if (cicloOrcamentarioRelatorioTotal) {
            const novoValor = cicloOrcamentarioRelatorioTotal.map((result) => {
                if (result.ano === ano) {
                    result.carregarMesAno = true;
                }
                return result;
            });
            setCicloOrcamentarioRelatorioTotal(novoValor);
        }
    }

    const bthExporta = () => {


        return [];
    }


    return (

        <ui.GridView noform>
            {cicloOrcamentarioRelatorioTotal && cicloOrcamentarioRelatorioTotal.length > 0 ? (
                cicloOrcamentarioRelatorioTotal.map((fechamentoRegistroEsin204) => {
                    return (<>
                        {
                            <Collapse
                                key={fechamentoRegistroEsin204.ano}
                                onChange={(key) => {
                                    carregarTadadosDaTabela(fechamentoRegistroEsin204.ano)
                                }}
                                bordered={false}
                                expandIcon={() => <Icon type="arrows-right_4" />}
                            >
                                <Panel key="2" header={`${fechamentoRegistroEsin204.ano}`} style={{ border: 0 }}>
                                    <ui.MasterDetailForm>
                                        <ui.Widget actions={bthExporta()}>
                                            {
                                                fechamentoRegistroEsin204.carregarMesAno === true ?
                                                    (
                                                        <FechamentoModuloExecutadoTabela
                                                            ano={fechamentoRegistroEsin204.ano}
                                                            carregarTabela={fechamentoRegistroEsin204.carregarMesAno}
                                                            fechamentoId={fechamentoId}
                                                            meses={fechamentoRegistroEsin204.meses}
                                                        />
                                                    ) :
                                                    (
                                                        <>
                                                        </>
                                                    )
                                            }
                                        </ui.Widget>
                                    </ui.MasterDetailForm>
                                </Panel>
                            </Collapse>
                        }
                    </>)
                })

            ) : (<> Não entrou </>)}
        </ui.GridView >

    );

}

export default FechamentoModuloExecutado;

